const templates = [
  {
    id: "wishlist-link",
    data: "wishlist",
    template: `
      <a
        href="{{ wishlist.url }}"
        class="header__icon-touch no-transition"
      >
      <span class="visually-hidden">Wishlist</span>
        <span class="icon-button icon-button-custom-heart">
          <span class="icon-button__icon">
            <span
              class="icon icon-new icon-custom-heart
              {% if wishlist.item_count > 0 %} is-filled{% endif %}"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.58 7.05647C17.2734 6.72154 16.9094 6.45585 16.5087 6.27457C16.108 6.0933 15.6786 6 15.2449 6C14.8112 6 14.3818 6.0933 13.9811 6.27457C13.5805 6.45585 13.2165 6.72154 12.9099 7.05647L12.2736 7.75124L11.6373 7.05647C11.018 6.38025 10.1781 6.00035 9.30226 6.00035C8.42644 6.00035 7.5865 6.38025 6.96721 7.05647C6.34792 7.73269 6 8.64984 6 9.60616C6 10.5625 6.34792 11.4796 6.96721 12.1558L7.60349 12.8506L12.2736 17.95L16.9437 12.8506L17.58 12.1558C17.8867 11.8211 18.13 11.4236 18.296 10.9861C18.4621 10.5486 18.5475 10.0797 18.5475 9.60616C18.5475 9.1326 18.4621 8.66369 18.296 8.22621C18.13 7.78872 17.8867 7.39124 17.58 7.05647Z"
                  stroke="currentColor"
                  stroke-linecap="round" />
              </svg>
            </span>
          </span>
        </span>
      </a>
    `,
  },
  {
    id: "wishlist-button",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}

      <button class="wishlist-icon-pdp" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">
        <span class="visually-hidden">Icon</span>
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M33.58 23.0565C33.2734 22.7215 32.9094 22.4558 32.5087 22.2746C32.108 22.0933 31.6786 22 31.2449 22C30.8112 22 30.3818 22.0933 29.9811 22.2746C29.5805 22.4558 29.2165 22.7215 28.9099 23.0565L28.2736 23.7512L27.6373 23.0565C27.018 22.3802 26.1781 22.0004 25.3023 22.0004C24.4264 22.0004 23.5865 22.3802 22.9672 23.0565C22.3479 23.7327 22 24.6498 22 25.6062C22 26.5625 22.3479 27.4796 22.9672 28.1558L23.6035 28.8506L28.2736 33.95L32.9437 28.8506L33.58 28.1558C33.8867 27.8211 34.13 27.4236 34.296 26.9861C34.4621 26.5486 34.5475 26.0797 34.5475 25.6062C34.5475 25.1326 34.4621 24.6637 34.296 24.2262C34.13 23.7887 33.8867 23.3912 33.58 23.0565Z"
                stroke="black" stroke-linecap="round" {% if product.in_wishlist %}fill="black"{% endif %} />
          <rect x="0.25" y="0.25" width="55.5" height="55.5" stroke="black" stroke-width="0.5" />
        </svg>
      </button>
    `,
  },
  {
    id: "wishlist-button-floating",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();
        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;
        
        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% if product.in_wishlist %}
        {% assign btn_text = locale.in_wishlist %}
        {% assign btn_title = locale.remove_from_wishlist %}
        {% assign btn_action = 'remove' %}
      {% else %}
        {% assign btn_text = locale.add_to_wishlist %}
        {% assign btn_title = locale.add_to_wishlist %}
        {% assign btn_action = 'add' %}
      {% endif %}

      {% assign scope = "product" %}
      {% assign targetId = product.id %}
      {% assign icon_name = "wishlist-icon" %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}
      
      <button class="icon icon-new icon-custom-heart" data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}">    
        <span class="visually-hidden">Add to wishlist</span>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.58 7.05647C17.2734 6.72154 16.9094 6.45585 16.5087 6.27457C16.108 6.0933 15.6786 6 15.2449 6C14.8112 6 14.3818 6.0933 13.9811 6.27457C13.5805 6.45585 13.2165 6.72154 12.9099 7.05647L12.2736 7.75124L11.6373 7.05647C11.018 6.38025 10.1781 6.00035 9.30226 6.00035C8.42644 6.00035 7.5865 6.38025 6.96721 7.05647C6.34792 7.73269 6 8.64984 6 9.60616C6 10.5625 6.34792 11.4796 6.96721 12.1558L7.60349 12.8506L12.2736 17.95L16.9437 12.8506L17.58 12.1558C17.8867 11.8211 18.13 11.4236 18.296 10.9861C18.4621 10.5486 18.5475 10.0797 18.5475 9.60616C18.5475 9.1326 18.4621 8.66369 18.296 8.22621C18.13 7.78872 17.8867 7.39124 17.58 7.05647Z"
            stroke="currentColor"
            stroke-linecap="round"
            {% if product.in_wishlist %}fill="black"{% endif %} />
        </svg>
      </button>
    `,
  },
  {
    id: "wishlist-button-cart",
    data: "product",
    events: {
      "click button[data-wk-add-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();
        const currentTarget = event.currentTarget;
        const container = currentTarget.closest('.cart__form-item-remove-wrapper') || undefined;

        const variantInput = document.querySelector("form *[name='id']");
        const variantId = variantInput ? variantInput.value : undefined;

        WishlistKing.toolkit.addProduct(
          event.currentTarget.getAttribute("data-wk-add-product"),
          variantId
        );
        
        if (container) {
          const removeBtn = container?.querySelector('[data-remove-item]');
          removeBtn.click();
        }
      },
      "click button[data-wk-remove-product]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeProduct(
          event.currentTarget.getAttribute("data-wk-remove-product")
        );
      },
      "click button[data-wk-remove-item]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.removeItem(
          event.currentTarget.getAttribute("data-wk-remove-item")
        );
      },
    },
    template: `
      {% assign btn_text = locale.move_to_wishlist %}
      {% assign btn_action = 'add' %}
      
      {% assign scope = "product" %}
      {% assign targetId = product.id %}

      {% if itemId %}
      {% assign scope = "item" %}
      {% assign targetId = itemId %}
      {% assign icon_name = "remove-icon" %}
      {% endif %}
      
      {% unless product.in_wishlist %}
      <button
        type="button"
        class="cart__form-item-remove btn-text-small btn-text text-brand-black wishlist-cart-btn"
        data-wk-{{ btn_action }}-{{ scope }}="{{ targetId }}"
        data-move-to-wishlist
      >
        {{ btn_text }}
      </button>
      {% endunless %}
    `,
  },
  {
    id: "wishlist-page",
    data: "wishlist",
    events: {
      "click a[data-wk-share]": (event) => {
        event.preventDefault();
        event.stopPropagation();

        WishlistKing.toolkit.requestWishlistSharing({
          wkShareService: event.currentTarget.getAttribute(
            "data-wk-share-service"
          ),
          wkShare: event.currentTarget.getAttribute("data-wk-share"),
          wkShareImage: event.currentTarget.getAttribute("data-wk-share-image"),
        });
      },
    },
    template: `
      <div
        class="wishlist-page {% if wishlist.item_count == 0 %}is-empty{% endif %}"
        data-wishlist-status="{% if wishlist.item_count == 0 %}empty{% else %}full{% endif %}"
      >
        <header class="wishlist-page__header">
          <h1 class="wishlist-page__heading">
            {% if wishlist.item_count == 0 %}
              Your Wishlist Is Empty
            {% else %}
              Wishlist
            {% endif %}
          </h1>
        </header>
        {% if wishlist.item_count == 0 %}
          <div class="button-block button-block__button button-block__button--justify-center button-block__button--justify-mobile-center">
            <a href="/" class="btn-secondary-white-border secondary-btn btn-text__no-underline wishlist-page__continue-btn">Continue Shopping</a>
          </div>
        {% else %}
          {% unless customer %}
            <p class="wishlist-page__content p-medium">
              Your wishlist will expire in 30 days unless you save it to your account.
            </p>
            <div class="button-block button-block__button button-block__button--justify-center button-block__button--justify-mobile-center">
              <a href="/account/login" class="btn-secondary-white-border secondary-btn btn-text__no-underline">Login</a>
              <a href="/account/register" class="btn-secondary-white-border secondary-btn btn-text__no-underline">Join Us</a>
            </div>
          {% endunless %}
        {% endif %}
      </div>
      <div class='wk-page {% if wishlist.read_only %}wk-page--shared{% endif %}'>
      {% if wishlist.item_count != 0 %}

        <div>
          <div class="wk-grid__override">
            {% assign item_count = 0 %}
            {% assign products = wishlist.products | reverse %}
            {% for product in products %}
              {% assign item_count = item_count | plus: 1 %}
              {% unless limit and item_count > limit %}
                {% assign hide_default_title = false %}
                {% if product.variants.length == 1 and product.variants[0].title contains 'Default' %}
                  {% assign hide_default_title = true %}
                {% endif %}

                {% assign variant = product.selected_or_first_available_variant %}
                {% if variant.price < variant.compare_at_price %}
                  {% assign onsale = true %}
                {% else %}
                  {% assign onsale = false %}
                {% endif %}
                <div class="wk-grid__item {% if onsale %}wk-product--sale{% endif %}" data-wk-item="{{ product.wishlist_item_id }}">
                  <a href="{{ product | variant_url }}" class="wk-product-image" title="{{ locale.view_product }}" style="background-image: url({{ product | variant_img_url: '1000x' }})">
                    <div class="wk-grid-heart-container">
                      {% unless wishlist.read_only %}
                        {% include "wishlist-button-floating" itemId: product.wishlist_item_id %}
                      {% else %}
                        {% include "wishlist-button-floating" product: product %}
                      {% endunless %}
                    </div>
                  </a>

                  <div class="wk-grid__item-text-wrapper">
                    <a href="{{ product | variant_url }}">
                      <p class="product-item__product-title p-small text-text-black font-300">{{ product.title }}</p>
                    </a>
                    <span class="ss__price p-small text-text-black font-300">
                      {{ variant.price | money }}
                    </span>
                  </div>
                  
                  {% include "wishlist-product-form" product: product %}
                </div>
              {% endunless %}
            {% endfor %}
          </div>
        </div>
        {% unless wishlist.read_only and wishlist.item_count > 0 %}
          <div class="wishlist-share">
            <p class="p-small wishlist-share__title">{{ locale.share_wishlist }}</p>
            <div class="wishlist-share__icons">
              {% include "wishlist-share-button-email" %}
              {% include "wishlist-share-button-link" %}
              {% include "wishlist-share-button-fb" %}
              {% include "wishlist-share-button-pinterest" %}
            </div>
            <div class="wk-sharing__link wk-sharing__link--hidden"><span class="wk-sharing__link-text"></span><button class="wk-sharing__link__copy-button" data-clipboard-target=".wk-sharing__link-text">{{ locale.copy_share_link }}</button></div>
          </div>
        {% endunless %}
      {% endif %}
      </div>
    `,
  },
  {
    id: "wishlist-product-form",
    events: {
      "render .wk-product-form": (form) => {
        const container = form.closest("[data-wk-item]");
        const itemId = container.getAttribute("data-wk-item");
        WishlistKing.toolkit.getItem(itemId).then((product) => {
          WishlistKing.toolkit.initProductForm(form, product, {
            // NOTE: Uncomment to override default option change
            // onOptionChange: (event) => {
            //   console.log(event.dataset);
            // },
            // NOTE: Uncomment to override default form submit
            // onFormSubmit: (event) => {
            //   event.preventDefault();
            //   event.stopPropagation();
            // },
          });
        });
      },
    },
    template: `
      <form class="wk-product-form" action="/cart/add" method="post">
        {% assign current_variant = product.selected_or_first_available_variant %}
        <div class="wk-product-form__options">
          <input name="id" value="{{ current_variant.id }}" type="hidden">
          {% unless product.has_only_default_variant %}
            {% for option in product.options_with_values %}
              <div class="wk-product-form__option select-wrapper dynamic-variant-input-wrap {% if option.name == 'Colour' %}hidden{% endif %}">
                <label class="wk-product-form__option__label" for="Option{{ option.position }}">
                  {{ option.name }}
                </label>
                <select class="wk-product-form__option__select input dynamic-variant-input p-medium" name="options[{{ option.name | escape }}]">
                  {% for value in option.values %}
                    <option value="{{ value | escape }}" {% if option.selected_value == value %}selected="selected"{% endif %} {% if option.soldout_values contains value %}disabled{% endif %}>
                      {{ value }}
                    </option>
                  {% endfor %}
                </select>
                <span class="icon icon-new">
                  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m7 9.952 5 5 5-5" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"/></svg>
                </span>
              </div>
            {% endfor %}
          {% endunless %}
          {% comment %}
          <div class="wk-product-form__quantity">
            <label class="wk-product-form__quantity__label" for="Quantity">{{ locale.quantity }}</label>
            <input class="wk-product-form__quantity__input" type="number" name="quantity" value="1" min="1">
          </div>
          {% endcomment %}
        </div>
        <button type="submit" class="btn-black btn-text-small" data-wk-add-to-cart="{{ product.wishlist_item_id }}" {% unless current_variant.available %}disabled{% endunless %}>
          {% if current_variant.available %}{{ locale.add_to_cart }}{% else %}{{ locale.sold_out }}{% endif %}
        </button>
      </form>
    `,
  },
  {
    id: "wishlist-page-shared",
    data: "shared_wishlist",
    template: `
      {% assign wishlist = shared_wishlist %}
      {% include "wishlist-page" with wishlist %}
    `,
  },
  {
    id: "wishlist-button-bulk-add-to-cart",
    data: "wishlist",
    events: {
      "click button[data-wk-bulk-add-to-cart]": (event) => {
        WishlistKing.toolkit.requestAddAllToCart(
          event.currentTarget.getAttribute("data-wk-bulk-add-to-cart")
        );
      },
    },
    template: `
      {% assign btn_text = locale.add_all_to_cart %}
      {% assign btn_title = locale.add_all_to_cart %}

      <button type="button" class="wk-button-bulk-add-to-cart" title="{{ btn_title }}" data-wk-bulk-add-to-cart="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-button-clear",
    data: "wishlist",
    events: {
      "click button[data-wk-clear-wishlist]": (event) => {
        WishlistKing.toolkit.clear(
          event.currentTarget.getAttribute("data-wk-clear-wishlist")
        );
      },
    },
    template: `
      {% assign btn_text = locale.clear_wishlist %}
      {% assign btn_title = locale.clear_wishlist %}

      <button type="button" class="wk-button-wishlist-clear" title="{{ btn_title }}" data-wk-clear-wishlist="{{ wishlist.permaId }}">
        <span class="wk-label">{{ btn_text }}</span>
      </button>
    `,
  },
  {
    id: "wishlist-icon",
    template: `
      <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path vector-effect="non-scaling-stroke" d="M32.012,59.616c-1.119-.521-2.365-1.141-3.707-1.859a79.264,79.264,0,0,1-11.694-7.614C6.316,42,.266,32.6.254,22.076,0.244,12.358,7.871,4.506,17.232,4.5a16.661,16.661,0,0,1,11.891,4.99l2.837,2.889,2.827-2.9a16.639,16.639,0,0,1,11.874-5.02h0c9.368-.01,17.008,7.815,17.021,17.539,0.015,10.533-6.022,19.96-16.312,28.128a79.314,79.314,0,0,1-11.661,7.63C34.369,58.472,33.127,59.094,32.012,59.616Z"/>
      </svg>
    `,
  },
  {
    id: "remove-icon",
    template: `
      <svg class="wk-icon__svg" width="100%" height="100%" viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <path vector-effect="non-scaling-stroke" d="M0.309,0.309a0.9,0.9,0,0,1,1.268,0L63.691,62.423a0.9,0.9,0,0,1-1.268,1.268L0.309,1.577A0.9,0.9,0,0,1,.309.309Z"/>
        <path vector-effect="non-scaling-stroke" d="M63.691,0.309a0.9,0.9,0,0,1,0,1.268L1.577,63.691A0.9,0.9,0,0,1,.309,62.423L62.423,0.309A0.9,0.9,0,0,1,63.691.309Z"/>
      </svg>
    `,
  },
  {
    id: "wishlist-share-button-fb",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.share_on_facebook }}" data-wk-share-service="facebook" data-wk-share="{{ wishlist.permaId }}" data-wk-share-image="{{ wishlist.products[0] | variant_img_url: '1200x630' }}">
        <svg viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M26.645 19.338h1.522v-2.65a19.718 19.718 0 0 0-2.216-.117c-2.194 0-3.697 1.38-3.697 3.916v2.334h-2.42v2.962h2.42v7.454h2.967v-7.454h2.324l.37-2.962H25.22V20.78c0-.856.23-1.442 1.424-1.442Z" fill="#000"/>
          <path stroke="#000" stroke-width=".5" d="M.25 1.154h47.5v47.5H.25z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-twitter",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.share_on_twitter }}" data-wk-share-service="twitter" data-wk-share="{{ wishlist.permaId }}">
        <svg version="1.1" x="0px" y="0px" width="100%" height="100%" viewBox="0 0 24 24">
        <path fill="currentColor" d="M23.444,4.834c-0.814,0.363-1.5,0.375-2.228,0.016c0.938-0.562,0.981-0.957,1.32-2.019c-0.878,0.521-1.851,0.9-2.886,1.104 C18.823,3.053,17.642,2.5,16.335,2.5c-2.51,0-4.544,2.036-4.544,4.544c0,0.356,0.04,0.703,0.117,1.036 C8.132,7.891,4.783,6.082,2.542,3.332C2.151,4.003,1.927,4.784,1.927,5.617c0,1.577,0.803,2.967,2.021,3.782 C3.203,9.375,2.503,9.171,1.891,8.831C1.89,8.85,1.89,8.868,1.89,8.888c0,2.202,1.566,4.038,3.646,4.456 c-0.666,0.181-1.368,0.209-2.053,0.079c0.579,1.804,2.257,3.118,4.245,3.155C5.783,18.102,3.372,18.737,1,18.459 C3.012,19.748,5.399,20.5,7.966,20.5c8.358,0,12.928-6.924,12.928-12.929c0-0.198-0.003-0.393-0.012-0.588 C21.769,6.343,22.835,5.746,23.444,4.834z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-whatsapp",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.share_with_whatsapp }}" data-wk-share-service="whatsapp" data-wk-share="{{ wishlist.permaId }}">
        <svg xmlns="https://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24">
          <path fill="currentColor" stroke="none" d="M20.1,3.9C17.9,1.7,15,0.5,12,0.5C5.8,0.5,0.7,5.6,0.7,11.9c0,2,0.5,3.9,1.5,5.6l-1.6,5.9l6-1.6c1.6,0.9,3.5,1.3,5.4,1.3l0,0l0,0c6.3,0,11.4-5.1,11.4-11.4C23.3,8.9,22.2,6,20.1,3.9z M12,21.4L12,21.4c-1.7,0-3.3-0.5-4.8-1.3l-0.4-0.2l-3.5,1l1-3.4L4,17c-1-1.5-1.4-3.2-1.4-5.1c0-5.2,4.2-9.4,9.4-9.4c2.5,0,4.9,1,6.7,2.8c1.8,1.8,2.8,4.2,2.8,6.7C21.4,17.2,17.2,21.4,12,21.4z M17.1,14.3c-0.3-0.1-1.7-0.9-1.9-1c-0.3-0.1-0.5-0.1-0.7,0.1c-0.2,0.3-0.8,1-0.9,1.1c-0.2,0.2-0.3,0.2-0.6,0.1c-0.3-0.1-1.2-0.5-2.3-1.4c-0.9-0.8-1.4-1.7-1.6-2c-0.2-0.3,0-0.5,0.1-0.6s0.3-0.3,0.4-0.5c0.2-0.1,0.3-0.3,0.4-0.5c0.1-0.2,0-0.4,0-0.5c0-0.1-0.7-1.5-1-2.1C8.9,6.6,8.6,6.7,8.5,6.7c-0.2,0-0.4,0-0.6,0S7.5,6.8,7.2,7c-0.3,0.3-1,1-1,2.4s1,2.8,1.1,3c0.1,0.2,2,3.1,4.9,4.3c0.7,0.3,1.2,0.5,1.6,0.6c0.7,0.2,1.3,0.2,1.8,0.1c0.6-0.1,1.7-0.7,1.9-1.3c0.2-0.7,0.2-1.2,0.2-1.3C17.6,14.5,17.4,14.4,17.1,14.3z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-pinterest",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.share_on_pinterest }}" data-wk-share-service="pinterest" data-wk-share="{{ wishlist.permaId }}" data-wk-share-image="{{ wishlist.products[0] | variant_img_url: '1200x630' }}">
        <svg viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M22.384 27.593c-.438 2.295-.972 4.495-2.556 5.644-.489-3.468.717-6.072 1.278-8.837-.956-1.608.115-4.843 2.13-4.046 2.478.98-2.148 5.977.957 6.602 3.243.65 4.566-5.625 2.555-7.666-2.904-2.948-8.454-.07-7.771 4.152.166 1.031 1.232 1.344.426 2.768-1.86-.412-2.414-1.879-2.343-3.834.115-3.2 2.874-5.439 5.643-5.75 3.5-.392 6.786 1.286 7.24 4.579.511 3.717-1.58 7.744-5.324 7.454-1.015-.08-1.44-.583-2.235-1.066Z" fill="#000"/>
          <path stroke="#000" stroke-width=".5" d="M.25 1.154h47.5v47.5H.25z"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-email",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.share_by_email }}" data-wk-share-service="email" data-wk-share="{{ wishlist.permaId }}">
        <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M31.6596 18.9042H16.3404C16.3381 18.9042 16.3358 18.9044 16.3335 18.9045L16.3336 18.9046C16.1488 18.9086 16 19.0745 16 19.2792V30.5292C16 30.7364 16.1525 30.9042 16.3404 30.9042H31.6596C31.8476 30.9042 32 30.7364 32 30.5292V19.2792C32 19.0719 31.8476 18.9042 31.6596 18.9042ZM30.8378 19.6542L26.3127 24.6388C26.3126 24.6389 26.3126 24.6389 26.3125 24.639L24 27.1864L21.6875 24.639C21.6874 24.6389 21.6872 24.6388 21.6871 24.6386L17.1623 19.6542H30.8378ZM16.6808 20.1844L20.9654 24.9041L16.6808 29.6239V20.1844ZM17.1623 30.1541L21.4468 25.4344L23.7593 27.9818C23.8778 28.1123 24.0631 28.1774 24.2408 27.9818L26.5532 25.4344L30.8378 30.1541H17.1623ZM31.3191 29.6238L27.0346 24.9041L31.3191 20.1845V29.6238Z" fill="currentColor"/>
          <rect x="0.25" y="1.15417" width="47.5" height="47.5" stroke="currentColor" stroke-width="0.5"/>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-link",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.get_link }}" data-wk-share-service="link" data-wk-share="{{ wishlist.permaId }}">
        <svg viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#a)" fill="#000">
            <path d="m29.049 19.855-.01-.01a3.26 3.26 0 0 0-4.593.009l-.008.008-2.057 2.057a.461.461 0 1 0 .653.652l2.064-2.064.007-.007a2.335 2.335 0 0 1 3.291.006l.008.009c.901.91.899 2.383-.008 3.29l-2.064 2.064a.461.461 0 0 0 .652.652l2.065-2.064a3.258 3.258 0 0 0 0-4.602ZM24.965 27.235l-2.063 2.063a2.316 2.316 0 0 1-.808.525 2.332 2.332 0 0 1-2.49-.524 2.336 2.336 0 0 1 0-3.298l2.064-2.063a.461.461 0 1 0-.66-.645l-2.057 2.056a3.26 3.26 0 0 0 0 4.602 3.253 3.253 0 0 0 3.475.733 3.231 3.231 0 0 0 1.14-.746l2.051-2.05a.461.461 0 1 0-.652-.653Z"/><path d="M21.639 27.264a.46.46 0 0 0 .652 0l4.07-4.07a.461.461 0 1 0-.652-.652l-4.07 4.07a.461.461 0 0 0 0 .652Z"/>
          </g>
          <path stroke="#000" stroke-width=".5" d="M.25 1.154h47.5v47.5H.25z"/>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M18 18.904h12v12H18z"/>
            </clipPath>
          </defs>
        </svg>
      </a>
    `,
  },
  {
    id: "wishlist-share-button-contact",
    data: "wishlist",
    template: `
      <a href="#" class="wk-share-btn-wrapper" title="{{ locale.send_to_customer_service }}" data-wk-share-service="contact" data-wk-share="{{ wishlist.permaId }}">
        <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      </a>
    `,
  },
];

export default templates;
